import React, { useState, useEffect, useRef } from "react";
import { useSnackbar } from "notistack";
import { format } from "date-fns";

import Loading from "../../components/Loading";
import Abas from "./Componentes/Abas";

import Formulario from "./Formulario";
import Cards from "./Cards";
import Tabela from "./Tabela";
import TabelaV2 from "../../componentsv2/Tabela";
import Box from "../../componentsv2/Box";

import { api } from "../../services/Api";

import "./styles.css";
import Header from "../../components/Header";
import { Container } from "@mui/system";
import {
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Autocomplete,
} from "@mui/material";

export default function PrecosExames() {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true);
  const [exames, setExames] = useState([]);
  const [tab, setTab] = useState(0);

  const [convenio, setConvenio] = useState("TODAS");
  const [cod_exame, setCod_exame] = useState("TODOS");
  const [tabelas, setTabelas] = useState([]);
  const [vetorExames, setVetorExames] = useState([]);

  const [somaQtdExamesPerdas, setSomaQtdExamesPerdas] = useState(0);
  const [somaPerdas, setSomaPerdas] = useState(0);
  const [somaGanho, setSomaGanho] = useState(0);
  const [somaMelhorGanho, setSomaMelhorGanho] = useState(0);
  const [somaAumento, setSomaAumento] = useState(0);
  const [percentAumento, setPercentAumento] = useState(0);

  const [dataInicial, setDataInicial] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());
  const [filtroExame, setFiltroExame] = useState("");
  const [filtroParceiro, setFiltroParceiro] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");
  const [guiaExames, setGuiaExames] = useState([]);
  const [opcoesExames, setOpcoesExames] = useState([]);
  const [opcoesParceiros, setOpcoesParceiros] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedExame, setSelectedExame] = useState(null);
  const [editedParceiro, setEditedParceiro] = useState("");
  const [editedCodExame, setEditedCodExame] = useState("");
  const [editedCodExameParceiro, setEditedCodExameParceiro] = useState("");
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [newParceiro, setNewParceiro] = useState("");
  const [newCodExame, setNewCodExame] = useState("");
  const [newCodExameParceiro, setNewCodExameParceiro] = useState("");
  const cacheDadosComparacaoPrecos = useRef(null);
  const ultimosFiltrosComparacaoPrecos = useRef(null);
  const carregandoComparacaoPrecos = useRef(false);
  const dadosEssenciaisCarregados = useRef(false);
  const tabAtualRef = useRef(tab);
  
  const cacheDadosExames = useRef(null);
  const ultimosFiltrosExames = useRef(null);
  const carregandoExames = useRef(false);

  const toDate = (value) => {
    if (value instanceof Date) {
      return value;
    }
    if (value) {
      return new Date(value);
    }
    return new Date();
  };

  const mnemonicos = vetorExames
    .filter(item => item.cod_exame && item.cod_exame !== "TODOS")
    .map(item => item.cod_exame)
    .sort();

  useEffect(() => {
    if (dadosEssenciaisCarregados.current) {
      return;
    }

    (async () => {
      setLoading(true);
      try {
        const results = await api.get("/v2/precosExames/tabelasConvenios");
        const lista1 = [{ cod_tabela: 0, convenio: "TODAS" }];
        const lista2 = results.data;
        const listaConvenio = lista1.concat(lista2);
        setTabelas(listaConvenio);
        const results2 = await api.get("/v2/precosExames/vetorExames");
        const lista3 = [{ cod_exame: "TODOS" }];
        const lista4 = results2.data;
        const listaExame = lista3.concat(lista4);
        setVetorExames(listaExame);
        dadosEssenciaisCarregados.current = true;
      } catch (error) {
        enqueueSnackbar(
          "Ocorreu um erro ao carregar as tabelas dos convênios. Tente novamente.",
          { variant: "error" }
        );
      } finally {
        if (tabAtualRef.current !== 0) {
          setLoading(false);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enqueueSnackbar]);

  useEffect(() => {
    tabAtualRef.current = tab;
  }, [tab]);

  useEffect(() => {
    if (tab !== 0) {
      return;
    }

    const dataInicialDate = toDate(dataInicial);
    const dataFinalDate = toDate(dataFinal);

    const filtrosAtuais = {
      convenio,
      cod_exame,
      dataInicial: dataInicialDate.getTime(),
      dataFinal: dataFinalDate.getTime(),
    };

    const filtrosMudaram = 
      !ultimosFiltrosComparacaoPrecos.current ||
      ultimosFiltrosComparacaoPrecos.current.convenio !== filtrosAtuais.convenio ||
      ultimosFiltrosComparacaoPrecos.current.cod_exame !== filtrosAtuais.cod_exame ||
      ultimosFiltrosComparacaoPrecos.current.dataInicial !== filtrosAtuais.dataInicial ||
      ultimosFiltrosComparacaoPrecos.current.dataFinal !== filtrosAtuais.dataFinal;

    if (!filtrosMudaram && cacheDadosComparacaoPrecos.current) {
      const dadosCache = cacheDadosComparacaoPrecos.current;
      setExames(dadosCache.exames);
      setSomaQtdExamesPerdas(dadosCache.somaQtdExamesPerdas);
      setSomaPerdas(dadosCache.somaPerdas);
      setSomaGanho(dadosCache.somaGanho);
      setSomaMelhorGanho(dadosCache.somaMelhorGanho);
      setSomaAumento(dadosCache.somaAumento);
      setPercentAumento(dadosCache.percentAumento);
      setLoading(false);
      return;
    }

    if (carregandoComparacaoPrecos.current) {
      return;
    }

    (async () => {
      carregandoComparacaoPrecos.current = true;
      setLoading(true);
      try {
        const data_inicial = format(dataInicialDate, "yyyy-MM-dd 00:00:00");
        const data_final = format(dataFinalDate, "yyyy-MM-dd 00:00:00");

        const resultado = await api.get(
          `/v2/precosExames/comparaPrecos/${convenio}/${cod_exame}/${data_inicial}/${data_final}`
        );
        const valores = resultado.data;

        setExames(valores);

        const somaExaperdas = valores.reduce((total, elemento) => {
          let valor = total;
          const ganhoDNA = elemento.preco_exame * elemento.quantidade_exame;
          const pagamento =
            elemento.preco_exame_parceiro * elemento.quantidade_exame;
          const caixa = ganhoDNA - pagamento;

          if (caixa < 0) {
            valor += caixa;
          }
          return valor;
        }, 0);

        const somaQtdExaperdas = valores.reduce((total, elemento) => {
          let valor = total;
          const ganhoDNA = elemento.preco_exame * elemento.quantidade_exame;
          const pagamento =
            elemento.preco_exame_parceiro * elemento.quantidade_exame;
          const caixa = ganhoDNA - pagamento;

          if (caixa < 0) {
            valor += 1;
          }
          return valor;
        }, 0);

        const somaAtGanho = valores.reduce((total, elemento) => {
          let valor = total;
          const ganhoDNA = elemento.preco_exame * elemento.quantidade_exame;
          const pagamento =
            elemento.preco_exame_parceiro * elemento.quantidade_exame;
          const caixa = ganhoDNA - pagamento;
          valor += caixa;
          return valor;
        }, 0);

        const somaMGanho = valores.reduce((total, elemento) => {
          let valor = total;
          const preco_db = elemento.preco_exame_db
            ? elemento.preco_exame_db
            : 100000000;
          const preco_dasa = elemento.preco_exame_dasa
            ? elemento.preco_exame_dasa
            : 100000000;
          const preco_hp = elemento.preco_hp
            ? elemento.preco_exame_hp
            : 100000000;

          let menor = Math.min(preco_db, preco_dasa, preco_hp);

          if (menor === 100000000) {
            menor = 0;
          }

          const ganhoDNA = elemento.preco_exame * elemento.quantidade_exame;
          const melhorGanho = menor * elemento.quantidade_exame;
          const caixa = ganhoDNA - melhorGanho;

          valor += caixa;
          return valor;
        }, 0);

        const somaAumento = somaMGanho - somaAtGanho;
        const percentAumento = somaAumento / somaAtGanho || 0;

        setSomaQtdExamesPerdas(somaQtdExaperdas);
        setSomaPerdas(somaExaperdas);
        setSomaGanho(somaAtGanho);
        setSomaMelhorGanho(somaMGanho);
        setSomaAumento(somaAumento);
        setPercentAumento(percentAumento);

        cacheDadosComparacaoPrecos.current = {
          exames: valores,
          somaQtdExamesPerdas: somaQtdExaperdas,
          somaPerdas: somaExaperdas,
          somaGanho: somaAtGanho,
          somaMelhorGanho: somaMGanho,
          somaAumento: somaAumento,
          percentAumento: percentAumento,
        };

        ultimosFiltrosComparacaoPrecos.current = filtrosAtuais;
      } catch (error) {
        enqueueSnackbar("Ocorreu um erro. Tente novamente.", {
          variant: "error",
        });
        setLoading(false);
        carregandoComparacaoPrecos.current = false;
        return;
      }
      setLoading(false);
      carregandoComparacaoPrecos.current = false;
    })();
  }, [enqueueSnackbar, convenio, cod_exame, dataInicial, dataFinal, tab]);

  const handleTabChange = (newValue) => {
    setTab(newValue);
  };

  const handleOpenModal = (exame) => {
    setSelectedExame(exame);
    setEditedParceiro(exame.cod_parceiro);
    setEditedCodExame(exame.cod_exame);
    setEditedCodExameParceiro(exame.cod_exame_parceiro);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedExame(null);
    setEditedParceiro("");
    setEditedCodExame("");
    setEditedCodExameParceiro("");
  };

  const montarFiltrosExames = ({
    parceiro = filtroParceiro,
    exame = filtroExame,
    status = filtroStatus,
  } = {}) => ({
    filtroParceiro: parceiro || "",
    filtroExame: exame || "",
    filtroStatus: status || "",
  });

  const recarregarListaExames = async (filtros = montarFiltrosExames()) => {
    const params = new URLSearchParams();
    if (filtros.filtroParceiro) {
      params.append("cod_parceiro", filtros.filtroParceiro);
    }
    if (filtros.filtroExame) {
      params.append("cod_exame", filtros.filtroExame);
    }
    if (filtros.filtroStatus) {
      params.append("ativo", filtros.filtroStatus);
    }

    const queryString = params.toString();
    const url = `/v2/guiaCodigoExameParceiros${queryString ? `?${queryString}` : ""}`;
    const resultado = await api.get(url);
    const data = resultado.data || [];

    const uniqueParceiros = [
      ...new Set(data.map((item) => item.cod_parceiro).filter(Boolean)),
    ].sort();
    const uniqueExames = [
      ...new Set(data.map((item) => item.cod_exame).filter(Boolean)),
    ].sort();

    setGuiaExames(data);
    setOpcoesParceiros(uniqueParceiros);
    setOpcoesExames(uniqueExames);

    cacheDadosExames.current = {
      guiaExames: data,
      opcoesParceiros: uniqueParceiros,
      opcoesExames: uniqueExames,
    };
    ultimosFiltrosExames.current = filtros;
  };

  const handleDesativarExame = async () => {
    if (!selectedExame) return;

    setLoading(true);
    try {
      await api.put(`/v2/guiaCodigoExameParceiros/${selectedExame.id}`, {
        cod_parceiro: selectedExame.cod_parceiro,
        cod_exame: selectedExame.cod_exame,
        cod_exame_parceiro: selectedExame.cod_exame_parceiro,
        ativo: false
      });
      
      enqueueSnackbar("Registro desativado com sucesso", { variant: "success" });
      handleCloseModal();
      await recarregarListaExames();
    } catch (error) {
      enqueueSnackbar("Erro ao desativar registro", { variant: "error" });
    }
    setLoading(false);
  };

  const handleAtivarExame = async () => {
    if (!selectedExame) return;

    setLoading(true);
    try {
      await api.put(`/v2/guiaCodigoExameParceiros/${selectedExame.id}`, {
        cod_parceiro: selectedExame.cod_parceiro,
        cod_exame: selectedExame.cod_exame,
        cod_exame_parceiro: selectedExame.cod_exame_parceiro,
        ativo: true
      });
      
      enqueueSnackbar("Registro ativado com sucesso", { variant: "success" });
      handleCloseModal();
      await recarregarListaExames();
    } catch (error) {
      enqueueSnackbar("Erro ao ativar registro", { variant: "error" });
    }
    setLoading(false);
  };

  const handleSaveExame = async () => {
    if (!editedParceiro || !editedCodExame || !editedCodExameParceiro) {
      enqueueSnackbar("Todos os campos são obrigatórios", { variant: "warning" });
      return;
    }

    setLoading(true);
    try {
      await api.put(`/v2/guiaCodigoExameParceiros/${selectedExame.id}`, {
        cod_parceiro: editedParceiro,
        cod_exame: editedCodExame,
        cod_exame_parceiro: editedCodExameParceiro,
      });
      
      enqueueSnackbar("Registro atualizado com sucesso", { variant: "success" });
      handleCloseModal();
      await recarregarListaExames();
    } catch (error) {
      enqueueSnackbar("Erro ao atualizar o registro. Tente novamente.", { variant: "error" });
    }
    setLoading(false);
  };

  const handleOpenCreateModal = () => {
    setCreateModalOpen(true);
  };

  const handleCloseCreateModal = () => {
    setCreateModalOpen(false);
    setNewParceiro("");
    setNewCodExame("");
    setNewCodExameParceiro("");
  };

  const handleCreateExame = async () => {
    if (!newParceiro || !newCodExame || !newCodExameParceiro) {
      enqueueSnackbar("Todos os campos são obrigatórios", { variant: "warning" });
      return;
    }

    setLoading(true);
    try {
      await api.post("/v2/guiaCodigoExameParceiros", {
        cod_parceiro: newParceiro,
        cod_exame: newCodExame,
        cod_exame_parceiro: newCodExameParceiro,
      });
      
      enqueueSnackbar("Exame criado com sucesso", { variant: "success" });
      handleCloseCreateModal();
      await recarregarListaExames();
    } catch (error) {
      enqueueSnackbar("Erro ao criar o exame. Tente novamente.", { variant: "error" });
    }
    setLoading(false);
  };


  const columnsAba1 = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      minWidth: 80,
      maxWidth: 100,
      flex: 0.5,
    },
    {
      field: "cod_parceiro",
      headerName: "Parceiro",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1.2,
    },
    {
      field: "cod_exame",
      headerName: "Código do Exame",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      flex: 1.3,
    },
    {
      field: "cod_exame_parceiro",
      headerName: "Código Exame Parceiro",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      flex: 1.5,
    },
    {
      field: "status",
      headerName: "Status",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      flex: 0.9,
      renderCell: (params) => (
        <span className={`status-badge-precos-exames ${params.row.ativo !== false ? "status-badge-precos-exames-ativo" : "status-badge-precos-exames-inativo"}`}>
          {params.row.ativo !== false ? "Ativo" : "Inativo"}
        </span>
      ),
    },
    {
      field: "acoes",
      headerName: "Ações",
      headerAlign: "center",
      align: "center",
      minWidth: 140,
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleOpenModal(params.row)}
        >
          Ver Detalhes
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (tab !== 1) {
      return;
    }

    const filtrosAtuaisExames = montarFiltrosExames();

    const filtrosMudaramExames = 
      !ultimosFiltrosExames.current ||
      ultimosFiltrosExames.current.filtroParceiro !== filtrosAtuaisExames.filtroParceiro ||
      ultimosFiltrosExames.current.filtroExame !== filtrosAtuaisExames.filtroExame ||
      ultimosFiltrosExames.current.filtroStatus !== filtrosAtuaisExames.filtroStatus;

    if (!filtrosMudaramExames && cacheDadosExames.current) {
      const dadosCache = cacheDadosExames.current;
      setGuiaExames(dadosCache.guiaExames);
      setOpcoesParceiros(dadosCache.opcoesParceiros);
      setOpcoesExames(dadosCache.opcoesExames);
      setLoading(false);
      return;
    }

    if (carregandoExames.current) {
      return;
    }

    (async () => {
      carregandoExames.current = true;
      setLoading(true);
      try {
        await recarregarListaExames(filtrosAtuaisExames);
      } catch (error) {
        console.error("Erro ao carregar exames:", error);
        enqueueSnackbar(
          error?.response?.data?.message || "Ocorreu um erro ao carregar os exames. Tente novamente.",
          { variant: "error" }
        );
        setLoading(false);
        carregandoExames.current = false;
        return;
      }
      setLoading(false);
      carregandoExames.current = false;
    })();
  }, [tab, filtroParceiro, filtroExame, filtroStatus, enqueueSnackbar]);

  return (
    <>
      {loading && <Loading />}
      <Header titulo="Preços de Exames" />
      <Container maxWidth="xl">
        <div className="container-abas-precos-exames">
          <Abas
            tabs={["Comparação de Preços", "Exames"]}
            value={tab}
            handleChange={(newValue) => handleTabChange(newValue)}
          />
        </div>
        {tab === 0 && (
          <>
            <Formulario
              tabelas={tabelas}
              vetorExames={vetorExames}
              setConvenio={setConvenio}
              setCod_exame={setCod_exame}
              dataInicial={dataInicial}
              setDataInicial={setDataInicial}
              dataFinal={dataFinal}
              setDataFinal={setDataFinal}
            />
            <Cards
              somaGanho={somaGanho}
              somaMelhorGanho={somaMelhorGanho}
              somaAumento={somaAumento}
              somaQtdExamesPerdas={somaQtdExamesPerdas}
              somaPerdas={somaPerdas}
              percentAumento={percentAumento}
            />
            <Tabela exames={exames} />
          </>
        )}
        {tab === 1 && (
          <>
            <Box
              sx={{
                mt: 2,
                mb: 2.5,
                display: "flex",
                gap: 1.5,
                flexWrap: "wrap",
                alignItems: "center",
                background: "white",
                px: { xs: 2, md: 4 },
                py: 2,
                borderRadius: 2,
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
              }}
            >
              <Autocomplete
                id="select-parceiro"
                value={filtroParceiro || "Todos os Parceiros"}
                onChange={(e, newValue) => {
                  if (newValue === "Todos os Parceiros") setFiltroParceiro("");
                  else setFiltroParceiro(newValue || "");
                }}
                options={["Todos os Parceiros", ...opcoesParceiros]}
                sx={{ flex: "1 1 220px", minWidth: { xs: "100%", sm: 220 } }}
                renderInput={(params) => <TextField {...params} label="Parceiro" variant="outlined" />}
              />
              <Autocomplete
                id="select-exame"
                value={filtroExame || "Todos os Exames"}
                onChange={(e, newValue) => {
                  if (newValue === "Todos os Exames") setFiltroExame("");
                  else setFiltroExame(newValue || "");
                }}
                options={["Todos os Exames", ...opcoesExames]}
                sx={{ flex: "1 1 220px", minWidth: { xs: "100%", sm: 220 } }}
                renderInput={(params) => <TextField {...params} label="Código do Exame" variant="outlined" />}
              />
              <Autocomplete
                id="select-status"
                value={filtroStatus === "true" ? "Ativo" : filtroStatus === "false" ? "Inativo" : "Todos os Status"}
                onChange={(e, newValue) => {
                  if (newValue === "Ativo") setFiltroStatus("true");
                  else if (newValue === "Inativo") setFiltroStatus("false");
                  else setFiltroStatus("");
                }}
                options={["Todos os Status", "Ativo", "Inativo"]}
                sx={{ flex: "1 1 180px", minWidth: { xs: "100%", sm: 180 } }}
                renderInput={(params) => <TextField {...params} label="Status" variant="outlined" />}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenCreateModal}
                sx={{ ml: { xs: 0, md: "auto" }, width: { xs: "100%", sm: "auto" } }}
              >
                Adicionar Exame
              </Button>
            </Box>
            <Paper
              sx={{
                backgroundColor: "white",
                width: "100%",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
              }}
            >
              <Box sx={{ height: 600, width: "100%" }}>
                <TabelaV2
                  rows={guiaExames}
                  columns={columnsAba1}
                  disableRowSelectionOnClick
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25, 50, 100]}
                  sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#f8fafc",
                      borderBottom: "1px solid #e2e8f0",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: 600,
                    },
                    "& .MuiDataGrid-cell": {
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": {
                      outline: "none",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "1px solid #e2e8f0",
                    },
                  }}
                />
              </Box>
            </Paper>
            
            <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
              <DialogTitle>Detalhes do Exame</DialogTitle>
              <DialogContent>
                {selectedExame && (
                  <div className="precos-exames-dialog-fields">
                    <TextField
                      label="ID"
                      value={selectedExame.id}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <TextField
                      label="Parceiro"
                      value={editedParceiro}
                      fullWidth
                      disabled
                      variant="outlined"
                    />
                    <Autocomplete
                      value={editedCodExame || null}
                      onChange={(e, newValue) => setEditedCodExame(newValue || "")}
                      options={mnemonicos}
                      freeSolo={false}
                      fullWidth
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Código do Exame"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                    <TextField
                      label="Código Exame Parceiro"
                      value={editedCodExameParceiro}
                      onChange={(e) => setEditedCodExameParceiro(e.target.value)}
                      fullWidth
                      variant="outlined"
                    />
                  </div>
                )}
              </DialogContent>
              <DialogActions>
                <div className="precos-exames-dialog-actions">
                  <div>
                    {selectedExame && selectedExame.ativo !== false ? (
                      <Button onClick={handleDesativarExame} variant="outlined" color="error">
                        Desativar
                      </Button>
                    ) : (
                      <Button onClick={handleAtivarExame} variant="outlined" color="success">
                        Ativar
                      </Button>
                    )}
                  </div>
                  <div className="precos-exames-dialog-actions-right">
                    <Button onClick={handleCloseModal} variant="outlined">
                      Cancelar
                    </Button>
                    <Button onClick={handleSaveExame} variant="contained">
                      Salvar
                    </Button>
                  </div>
                </div>
              </DialogActions>
            </Dialog>
            
            <Dialog open={createModalOpen} onClose={handleCloseCreateModal} maxWidth="sm" fullWidth>
              <DialogTitle>Adicionar Novo Exame</DialogTitle>
              <DialogContent>
                <div className="precos-exames-dialog-fields">
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="parceiro-select-label">Parceiro</InputLabel>
                    <Select
                      labelId="parceiro-select-label"
                      value={newParceiro}
                      onChange={(e) => setNewParceiro(e.target.value)}
                      label="Parceiro"
                    >
                      <MenuItem value="">
                        <em>Selecione um parceiro</em>
                      </MenuItem>
                      {opcoesParceiros.map((parceiro) => (
                        <MenuItem key={parceiro} value={parceiro}>
                          {parceiro}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Autocomplete
                    value={newCodExame || null}
                    onChange={(e, newValue) => setNewCodExame(newValue || "")}
                    options={mnemonicos}
                    freeSolo={false}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Código do Exame"
                        variant="outlined"
                        required
                      />
                    )}
                  />
                  <TextField
                    label="Código Exame Parceiro"
                    value={newCodExameParceiro}
                    onChange={(e) => setNewCodExameParceiro(e.target.value)}
                    fullWidth
                    variant="outlined"
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseCreateModal} variant="outlined">
                  Cancelar
                </Button>
                <Button onClick={handleCreateExame} variant="contained">
                  Criar
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Container>
    </>
  );
}
